<article class="palette-card" [ngClass]="palette.name">
  <figure class="palette-card__colors">
    <div class="bg-primary text-center d-block">
      <h1 class="h2 text-primary-text mb-0">Aa</h1>
      <span class="text-muted-light">muted-light text</span>
    </div>
    <div class="bg-background text-center d-block">
      <h1 class="h2 text-background-text-color mb-2">Aa</h1>
      <button class="button button-outline button--theme-overlay">Knop</button>
    </div>
    <div class="bg-background-light">
      <h1 class="h2 text-dark mb-0">Aa</h1>
    </div>
    <!-- <div class="bg-tertiary fw-bold">accent</div> -->
    <figcaption class="palette-card__meta">
      <strong>{{ palette.name }}</strong>
      <br />
      <span class="text-muted-light">muted-light text</span>
      <br />
      <button class="button button--primary me-2 mt-3">Knop 1</button>
      <button class="button button--secondary mt-3">Knop 2</button>
    </figcaption>
  </figure>
</article>
